import * as React from 'react';

export const auFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_501)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#1A47B8'
            />
            <mask
                id='mask0_1_501'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_501)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#1A47B8'
                />
                <mask
                    id='mask1_1_501'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='0'
                    y='-1'
                    width='15'
                    height='11'
                >
                    <path
                        d='M0 -0.459961H14.6701V9.29797H0V-0.459961Z'
                        fill='#000008'
                    />
                </mask>
                <g mask='url(#mask1_1_501)'>
                    <path
                        d='M15.2109 0.352539L9.09668 4.41895L15.2109 8.48535L14.1299 10.1104L7.33496 5.58984L0.540039 10.1104L-0.540039 8.48535L5.57324 4.41895L-0.540039 0.352539L0.540039 -1.27246L7.33496 3.24707L14.1299 -1.27246L15.2109 0.352539Z'
                        fill='#F1F5F9'
                    />
                </g>
                <mask
                    id='mask2_1_501'
                    style={{ maskType: 'alpha' }}
                    maskUnits='userSpaceOnUse'
                    x='0'
                    y='-1'
                    width='15'
                    height='11'
                >
                    <path
                        d='M0 -0.459961V4.419H14.6701V9.29797L0 -0.459961ZM14.6701 -0.459961H7.33504V9.29797H0L14.6701 -0.459961Z'
                        fill='#000008'
                    />
                </mask>
                <g mask='url(#mask2_1_501)'>
                    <path
                        d='M15.0303 0.0820312L8.50977 4.41895L15.0303 8.75586L14.3096 9.83984L7.33496 5.2002L0.360352 9.83984L-0.360352 8.75586L6.15918 4.41895L-0.360352 0.0820312L0.360352 -1.00195L7.33496 3.63672L14.3096 -1.00195L15.0303 0.0820312Z'
                        fill='#F93939'
                    />
                </g>
                <path
                    d='M8.96104 -0.459961V2.79301H14.6701V6.045H8.96104V9.29797H5.70905V6.045H0V2.79301H5.70905V-0.459961H8.96104Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M8.31064 -0.459961V3.44341H14.6701V5.3946H8.31064V9.29797H6.35945V5.3946H0V3.44341H6.35945V-0.459961H8.31064Z'
                    fill='#F93939'
                />
                <path
                    opacity='0.5'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M5.33334 15.3333L6.66668 14.6667L7.33334 13.3333L8.00001 14.6667L9.33334 15.3333L8.00001 16L7.33334 17.3333L6.66668 16L5.33334 15.3333ZM18.6667 4V5.33333H20V4H18.6667ZM22.6667 5.33333V6.66667H24V5.33333H22.6667ZM17.3333 8V9.33333H18.6667V8H17.3333ZM21.3333 9.33333V10.6667H22.6667V9.33333H21.3333ZM20 13.3333V14.6667H21.3333V13.3333H20Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_501'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
